import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Home/Header";
import Education from "./Pages/Education/page.js";
import RealEstate from "./Pages/Realestate/page.js";
import TravelLeadSection from "./Pages/Travelagency/page.js";
import Beauty from "./Pages/Beauty & Cosmetics/page.js";
import Salonpage from "./Pages/Spas and Salons/page.js";
import Restaurant from "./Pages/Restaurant & Food/page.js";
import Health from "./Pages/Health & Wellness/page.js";
import Homedecor from "./Pages/Home Decor/page.js";
import Automative from "./Pages/Automative/page.js";
import Marketing from "./Pages/Marketing Agency/page.js";
import Freelancer from "./Pages/Freelancer and Consultant/page.js";
import Banking from "./Pages/Banking and Finance/page.js";
import Home2 from "./Home/Home2.js";
import Edutech from "./Pages/Edutech/Page.js";
import ITservices from "./Pages/IT services & internet/Page.js";
import Retail from "./Pages/Offline & Retail/Page.js";
import Event from "./Pages/Event & Webinar/Pages.js";


function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home2 />} /> {/* Home page as default route */}
        <Route path="/whatsapp-business-for-education" element={<Education />} />
        <Route path="/whatsapp-business-for-real-estate" element={<RealEstate />} />
        <Route path="/whatsapp-business-for-travel-and-tourism" element={<TravelLeadSection />} />
        <Route path="/whatsapp-business-for-beauty-cosmetics-brands" element={<Beauty />} />
        <Route path="/whatsapp-business-for-spas-and-salons" element={<Salonpage />} />
        <Route path="/whatsapp-business-for-health-wellness-brands" element={<Health />} />
        <Route path="/whatsapp-business-for-restaurants-food-businesses" element={<Restaurant />} />
        <Route path="/whatsapp-business-for-home-decor-and-furnishings" element={<Homedecor />} />
        <Route path="/whatsapp-business-for-automotive-industry" element={<Automative />} />
        <Route path="/whatsapp-business-for-marketing-agency" element={<Marketing />} />
        <Route path="/whatsapp-business-for-freelancer-and-consultant-sales" element={<Freelancer />} />
        <Route path="/whatsapp-business-for-banking-and-finance" element={<Banking />} />
        <Route path="/whatsapp-business-for-edutech" element={<Edutech />} />
        <Route path="/whatsapp-business-for-IT-services-and-internet" element={<ITservices />} />
        <Route path="/whatsapp-business-for-offline-and-retail" element={<Retail />} />
        <Route path="/whatsapp-business-for-event-and-webinar" element={<Event />} />
      </Routes>
    </Router>
  );
}

export default App;
